export const DISRUPTION_POLLING_INTERVAL = 10000;
export const DESCRIPTION_MAX_LENGTH = 5000;
export const DESCRIPTION_NOTE_MAX_LENGTH = 5000;
export const HEADER_MAX_LENGTH = 150;
export const URL_MAX_LENGTH = 250;
export const MAX_NUMBER_OF_ENTITIES = 200;
export const TIME_FORMAT = 'HH:mm';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

export const LABEL_CAUSE = 'Cause';
export const LABEL_MODE = 'Mode';
export const LABEL_AFFECTED_ROUTES = 'Affected Routes';
export const LABEL_AFFECTED_STOPS = 'Affected Stops';
export const LABEL_ROUTES = 'Routes';
export const LABEL_STOPS = 'Stops';
export const LABEL_START_DATE = 'Start Date';
export const LABEL_START_TIME = 'Start Time';
export const LABEL_END_DATE = 'End Date';
export const LABEL_END_TIME = 'End Time';
export const LABEL_STATUS = 'Status';
export const LABEL_DISRUPTION = 'Disruption';
export const LABEL_CUSTOMER_IMPACT = 'Effect';
export const LABEL_HEADER = 'Disruption Title';
export const LABEL_EFFECT_HEADER = 'Effect Title';
export const LABEL_DESCRIPTION = 'Description';
export const LABEL_URL = 'URL';
export const LABEL_CREATED_BY = 'Created By';
export const LABEL_LAST_UPDATED_BY = 'Last Updated By';
export const LABEL_CREATED_AT = 'Created At';
export const LABEL_LAST_UPDATED_AT = 'Last Updated At';
export const LABEL_FREQUENCY = 'Frequency';
export const LABEL_DURATION_HOURS = 'Duration (hours)';
export const LABEL_WORKAROUNDS = 'Workarounds';
export const LABEL_DISRUPTION_NOTES = 'Disruption Notes';
export const LABEL_LAST_NOTE = 'Last Note';
export const LABEL_SEVERITY = 'Severity';
export const LABEL_PASSENGER_IMPACT = 'Passenger Impact';
export const LABEL_NOTE = 'Note';
export const LABEL_DURATION = 'Duration';
export const LABEL_START_TIME_DATE = 'Start Time/Date';
export const LABEL_END_TIME_DATE = 'End Time/Date';
export const LABEL_IS_RECURRING = 'Recurring?';
export const LABEL_RECURRING_PERIOD = 'Recurring Period';

export const STOP_NOT_AVAILABLE = 'Stop not available';

export const FREQUENCY_TYPE = {
    ONCE: 'Once',
    RECURRING: 'Recurring',
};

export const NOTE_DISCLAIMER = `This notification is a communication tool to inform multiple internal and external stakeholders about a disruption. 
Auckland Transport does not deem this notification as evidence of actual impact to service. Auckland Transport advises that 
the agreed operational data and metrics will need to be utilised to ascertain the actual impact to service performance.`;
